import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {ACTION, STATUS} from '../constant';

@Injectable()
export class ParticipationFormCleanupResolve implements Resolve<Observable<any>> {

  participationForm$: Observable<any>;

  constructor(private store: Store<any>) {
    this.participationForm$ = this.store.select('PARTICIPATION_FORM_REDUCER');
  }

  resolve(route: ActivatedRouteSnapshot): any {

    let submissionCode = route.params['submissionCode'];

    this.store.dispatch({
      type: ACTION.PARTICIPATION_FORM_LOAD_CLEANUP,
      payload: {formSubmissionCode: submissionCode, cleanupInProgress: true}
    });

    return this.participationForm$
      .filter(state => state.status === STATUS.COMPLETED)
      .map(state => state.data)
      .first();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/resolves/participation-form-cleanup.resolve.ts